import { put, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';
import { transformResponseToShares, transformShareToRequestData } from './transformers';

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'shares',
    resourceBaseUrl: '/datasets/shares',
    getLastSyncDate,

    transformResponseToResources: transformResponseToShares,
    transformResourceToRequestData: transformShareToRequestData,

    successAction,
    failureAction,
  });

function* getSharesActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getSharesSuccess, actions.getSharesFailure);
  yield takeEvery(actions.getShares, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

function* createShareActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createShareSuccess, actions.createShareFailure);
  yield takeEvery(actions.createShare, resourceSagaUtils.qcsSyncCreateResource, resourceConfig);
}

function* updateShareActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateShareSuccess, actions.updateShareFailure);
  yield takeEvery(actions.updateShare, resourceSagaUtils.qcsSyncUpdateResource, resourceConfig);
}

function* deleteShareActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteShareSuccess, actions.deleteShareFailure);
  yield takeEvery(actions.deleteShare, resourceSagaUtils.qcsSyncDeleteResource, resourceConfig);
}

function* createShareSuccessActionWatcher() {
  yield takeEvery(actions.createShareSuccess, function* createSharesSuccess() {
    yield put(actions.getShares());
  });
}

export default [
  getSharesActionWatcher,
  createShareActionWatcher,
  updateShareActionWatcher,
  deleteShareActionWatcher,
  createShareSuccessActionWatcher,
];
